import { format, isEqual, isWithinInterval } from 'date-fns';
import { FORMAT_DATE } from '../../constants';
import { ESTADO_DENUNCIA } from '../../lib/denuncia.enum';

const SEARCH_OPTIONS = [{ label: 'ID', value: 'id', placeholder: 'Buscar por ID..' }];

const SELECT_OPTIONS = [
  { label: 'Abierta', value: 'ABIERTA' },
  { label: 'En proceso', value: 'ENPROCESO' },
  { label: 'Pendiente', value: 'PENDIENTERESPUESTA' },
  { label: 'Finalizada', value: 'FINALIZADA' },
  { label: 'Desestimada', value: 'DESESTIMADA' },
  { label: 'Enviada', value: 'ENVIADA' },
];

const generateFilter = ({ id, status, date }) => {
  let applyFilter = {};

  if (id) {
    applyFilter = { id };
  }

  if (status) {
    applyFilter = { ...applyFilter, status: ESTADO_DENUNCIA[status.value] };
  }
  if (date) {
    applyFilter = { ...applyFilter, fechaExpedicionDesde: format(date[0], FORMAT_DATE.FILTER) };
    if (date[1] !== null) {
      applyFilter = { ...applyFilter, fechaExpedicionHasta: format(date[1], FORMAT_DATE.FILTER) };
    }
  }

  return applyFilter;
};

const localFilterData = ({ data, filter, idPermission }) => {
  if (!filter) {
    return data;
  }

  let dataFiltered = data;

  if (filter.id) {
    dataFiltered = dataFiltered.filter(({ complaint: { id, publicId } }) => {
      const finalId = idPermission ? String(id) : publicId;
      return finalId.includes(filter.id);
    });
  }

  if (filter.status) {
    dataFiltered = dataFiltered.filter(({ complaint: { status } }) => status === filter.status);
  }

  if (filter.fechaExpedicionDesde && !filter.fechaExpedicionHasta) {
    dataFiltered = dataFiltered.filter(({ complaint: { creationDate } }) =>
      isEqual(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), new Date(filter.fechaExpedicionDesde))
    );
  }

  if (filter.fechaExpedicionHasta) {
    dataFiltered = dataFiltered.filter(({ complaint: { creationDate } }) =>
      isWithinInterval(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), {
        start: new Date(filter.fechaExpedicionDesde),
        end: new Date(filter.fechaExpedicionHasta),
      })
    );
  }

  return dataFiltered;
};

export { SEARCH_OPTIONS, SELECT_OPTIONS, localFilterData, generateFilter };
